<template>
    <b-modal :visible="value" content-class="argus-glass-dialog" centered scrollable
        :title="submitMode ? 'Уточните срок перед отправкой' : 'Срок и срочность'"
        :no-close-on-backdrop="saving" :no-close-on-esc="saving" :hide-header-close="saving"
        @change="$emit('input', $event)" @show="reset" @hide="onHide">
        <p v-if="submitMode" class="mb-2">Чтобы отправить заявку, проверьте срок и при необходимости объясните срочность.</p>
        <p class="small text-muted">Текущий срок: <strong>{{ formatDeadline(request.deadline) }}</strong></p>
        <b-alert v-if="!canEdit" show variant="warning">
            У вас нет права менять срок и срочность этой заявки. Исправить их должен участник с соответствующим правом.
        </b-alert>
        <RequestDeadlineInput v-model="form.deadline" id="deadline-dialog" :disabled="saving || !canEdit" :now="now" />
        <p v-if="policy.requiredDays && !type.is_emergency" class="small text-muted">
            Регламент: {{ policy.requiredDays }} дн. Обычный срок — с {{ policy.minimumDate.split('-').reverse().join('.') }}.
        </p>
        <b-form-group label="Приоритет" label-for="deadline-dialog-priority">
            <b-form-select id="deadline-dialog-priority" v-model="form.priority" :options="priorities" :disabled="saving || !canEdit" />
        </b-form-group>
        <b-alert v-if="policy.urgent" show variant="warning" class="small">
            <template v-if="form.priority === 'urgent'">Выбран срочный приоритет. Перенос даты сам по себе его не снимает.</template>
            <template v-else>Выбранный срок меньше регламентного.</template>
            <span v-if="policy.reasonRequired"> Укажите причину срочности.</span>
        </b-alert>
        <b-form-group v-if="policy.urgent" label="Причина срочности" label-for="deadline-dialog-reason">
            <DiscussionEditor id="deadline-dialog-reason" v-model="form.urgency_comment"
                :disabled="saving || !canEdit" placeholder="Почему заявку нужно выполнить раньше обычного срока?" />
        </b-form-group>
        <b-form-group v-if="commentRequired" label="Комментарий к отправке" label-for="deadline-dialog-comment">
            <DiscussionEditor id="deadline-dialog-comment" v-model="comment" :disabled="saving" />
        </b-form-group>
        <template #modal-footer>
            <div class="w-100">
                <div v-if="error || policy.code" role="alert" aria-live="polite" class="small mb-2"
                    :class="error ? 'text-danger' : 'text-muted'">{{ error || policy.message }}</div>
                <div v-if="commentRequired && !comment.trim()" class="small text-muted mb-2">Добавьте комментарий к отправке.</div>
                <div class="d-flex justify-content-end flex-wrap">
                    <b-button variant="outline-secondary" :disabled="saving" class="mr-2 mb-1" @click="$emit('input', false)">Отмена</b-button>
                    <b-button variant="primary" class="mb-1" :disabled="saving || !canEdit || !!policy.code || (commentRequired && !comment.trim())"
                        @click="confirm">
                        <b-spinner v-if="saving" small class="mr-1" />
                        {{ submitMode ? 'Сохранить и отправить' : 'Сохранить' }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import RequestDeadlineInput from './RequestDeadlineInput.vue';
import {deadlinePolicy, normalizeDeadline, formatDeadline} from '@/utils/requestDeadline';
export default {
    name: 'RequestDeadlineModal',
    components: {RequestDeadlineInput},
    props: {
        value: Boolean, request: {type: Object, required: true}, saving: Boolean, submitMode: Boolean,
        error: {type: String, default: ''}, canEdit: {type: Boolean, default: true}, commentRequired: Boolean,
        initialComment: {type: String, default: ''}, serverNow: {type: String, default: null}
    },
    data() {
        return {form: {deadline: null, priority: 'normal', urgency_comment: ''}, comment: '',
            now: Date.now(), clockOffset: 0, timer: null,
            priorities: [{value: 'low', text: 'Низкий'}, {value: 'normal', text: 'Обычный'},
                {value: 'high', text: 'Высокий'}, {value: 'urgent', text: 'Срочный'}]};
    },
    computed: {
        type() { return this.request.RequestType || {}; },
        policy() { return deadlinePolicy(this.type, this.form, this.now); }
    },
    watch: {serverNow(value) { if (value) this.clockOffset = new Date(value).getTime() - Date.now(); }},
    beforeDestroy() { clearInterval(this.timer); },
    methods: {
        formatDeadline,
        reset() {
            const deadline = normalizeDeadline(this.request.deadline);
            this.form = {deadline: deadline ? deadline.toISOString() : null, priority: this.request.priority || 'normal',
                urgency_comment: this.request.urgency_comment || ''};
            this.comment = this.initialComment;
            this.now = Date.now() + this.clockOffset;
            clearInterval(this.timer);
            this.timer = setInterval(() => { this.now = Date.now() + this.clockOffset; }, 1000);
        },
        onHide(event) { if (this.saving) event.preventDefault(); else clearInterval(this.timer); },
        confirm() {
            this.now = Date.now() + this.clockOffset;
            if (this.policy.code || this.saving || !this.canEdit) return;
            this.$emit('confirm', {...this.form, urgency_comment: this.policy.urgent ? this.form.urgency_comment.trim() : '',
                comment: this.comment.trim()});
        }
    }
};
</script>
